var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10965_182712",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.386719,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10965_182712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10.3861L13.875 15.5111C13.7222 15.7333 13.5244 15.9069 13.2817 16.0319C13.0383 16.1569 12.7778 16.2194 12.5 16.2194H4.16667C3.70833 16.2194 3.31583 16.0563 2.98917 15.7302C2.66306 15.4036 2.5 15.0111 2.5 14.5527V6.2194C2.5 5.76107 2.66306 5.36885 2.98917 5.04273C3.31583 4.71607 3.70833 4.55273 4.16667 4.55273H12.5C12.7778 4.55273 13.0383 4.61523 13.2817 4.74023C13.5244 4.86523 13.7222 5.03885 13.875 5.26107L17.5 10.3861ZM15.4583 10.3861L12.5 6.2194H4.16667V14.5527H12.5L15.4583 10.3861Z",
    fill: "#959595"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabelIcon);
export default __webpack_public_path__ + "static/media/labelIcon.5801d2500d5a8bc9f4b6289347d47ea3.svg";
export { ForwardRef as ReactComponent };